import axios, {
  AxiosError,
  AxiosResponse,
  type AxiosRequestConfig,
} from "axios";
import { router } from "routers";

const token = localStorage.getItem("accessToken");

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 5000,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (respone) => respone,
  (error) => handleRequestError(error)
);

interface MyAxiosRequestConfig extends AxiosRequestConfig {
  _retry?: boolean;
}
const handleRequestError = async (error: AxiosError): Promise<void> => {
  const config: MyAxiosRequestConfig = error.config || {};
  if (error.response?.status === 401 && !config._retry) {
    const controller = new AbortController();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { signal } = controller;
    config._retry = true;
    localStorage.clear();
    router.navigate("/login");
  }
  return Promise.reject(error);
};

export function transformRequest<T>(
  config: AxiosRequestConfig
): Promise<[null, T] | [AxiosError<unknown, any>, null]> {
  return axiosInstance.request(config).then(
    (val: AxiosResponse<T>) => [null, val || val] as unknown as [null, T],
    (err: AxiosError) => [err, null] as [AxiosError, null]
  );
}
export default axiosInstance;
